import { createFileRoute } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { useLogout } from '@/hooks/auth/useLogout'
import { ConnectInstagram } from '@/components/settings/ConnectInstagram'
import { CollapsibleSettings } from '@/components/settings/CollapsibleSettings'
import { BalanceAccount } from '@/components/balance/BalanceAccount'
import { useIsMobile } from '@/hooks/useIsMobile'

export const Route = createFileRoute('/_app/settings')({
  component: Settings,
})

function Settings() {
  const { logout, isLoading } = useLogout()
  const isMobile = useIsMobile()

  return (
    <div className="flex flex-col h-full py-6 pb-0 bg-background md:pt-10">
      <div className="flex justify-between items-center px-6">
        <h1 className="text-[28px] font-semibold text-foreground">Settings</h1>
        {isMobile && <BalanceAccount tooltipSide="left" />}
      </div>
      <div className="flex-1 pt-5 md:w-[652px]">
        <CollapsibleSettings />
        <div className="px-6">
          <Separator />
        </div>
        <ConnectInstagram />
        <div className="px-6">
          <Separator />
        </div>
        {isMobile && (
          <div className="py-5 px-6">
            <Button
              variant="ghost"
              onClick={logout}
              loading={isLoading}
              disabled={isLoading}
              className="text-base font-normal leading-[1.5] text-[var(--black)] relative right-6"
            >
              Logout
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
